import { useOAIQuery } from '~/hooks/reactQuery';

export const useTopPrCategory = () => {
  const { data, ...props } = useOAIQuery({
    queryKey: '/api/market-place/v1/top-pv/categories',
    queryOptions: {
      keepPreviousData: true,
    },
    variables: {
      hour: new Date().getHours(),
    },
  });
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    data: data?.data || [],
    ...props,
  };
};
